import React, {useEffect} from "react";
import {IonItem, IonLabel, IonSelect, IonSelectOption, useIonAlert} from "@ionic/react";
import {useMutation, useQuery} from "@apollo/client";
import {
    USER_GET_RULES_QUERY,
    USER_MANAGER_UPDATE_USER_ADD_RULE,
    USER_MANAGER_UPDATE_USER_REMOVE_RULE
} from "../../schemas/userManager";



const UserManagerEditUserRules: React.FC<any> = ({user, refetch}:any) => {
    const [presentAlert, dismissAlert] = useIonAlert();
    const [rules, setRules] = React.useState<{name:string, roleId: number | undefined}[]>([]);
    const [addRuleVal, setAddRuleVal] = React.useState<number | undefined>(undefined)
    const [removeRuleMutation] = useMutation(USER_MANAGER_UPDATE_USER_REMOVE_RULE);
    const [addRuleMutation] = useMutation(USER_MANAGER_UPDATE_USER_ADD_RULE);

    const {loading:rulesLoading, error:rulesError, data: rulesData} = useQuery(USER_GET_RULES_QUERY, {variables: {}});


    useEffect( () => {
        if (user) {
            let rulesCombined: { name: string, roleId: number | undefined, ruleId: number }[] = [];
            if (user && user.user_roles) {
                rulesCombined = user.user_roles.flatMap((user_role: any) => {
                    return user_role.roles.role_rules.map((rule: any) => {

                        return {name: rule.rules.name, roleId: rule.role_id, ruleId: rule.rule_id};
                    });
                });
            }
            if (user && user.user_rules) {
               rulesCombined = rulesCombined.concat(user.user_rules.map((user_rule: any) => {
                    return {name: user_rule.rules.name, ruleId: user_rule.rule_id};
                }));
            }
            setRules(rulesCombined);
        }
        }, [user]);


    const removeRule = async (ruleId: number) => {
        if (window.confirm('Are you sure you want to remove this rule?')) {
            const results = await removeRuleMutation({variables: {data: {ruleId: ruleId, userId: user.id}}});
            await refetch();
        }
    };
    const addRule = async (ruleId: number)=> {
        if (ruleId) {
            const results = await addRuleMutation({variables: {data: {ruleId: ruleId, userId: user.id}}});
            await refetch();
        }
    };

    return (
        <div className="ion-padding panel" slot="content">

            {rules && rules.filter((value, index, self) =>
                // filter to unique rule names
                index === self.findIndex((t) => (
                t.name === value.name
                ))
                ).map((rule:any) => {

                return (
                    <div key={'rule_'+rule.name} className="badge" style={{float: 'left', backgroundColor: '#3880ff', display: 'inline-block', margin: '5px', padding: '5px 10px 5px 10px'}}>
                        {rule.name}
                        {!rule.roleId &&
                            <button style={{marginLeft: '5px', backgroundColor: 'transparent'}} onClick={() => removeRule(rule.ruleId)}>X</button>
                        }

                    </div>
                )
            })}
            <div style={{clear: 'both'}}></div>
            <div>
                Add Rule to User:
                <IonSelect label="Rule" labelPlacement="start" value={addRuleVal} onIonChange={(e) => addRule(e.detail.value)}>
                    {rulesData && rulesData.getRules.map((rule:any) => {
                        let found = false;
                        rules.forEach((rule2:any) => {
                            if (rule.id === rule2.ruleId) {
                                found = true;
                            }
                        })
                        if (!found) {
                            return (
                                <IonSelectOption value={rule.id} key={'rule_' + rule.id}>{rule.name}</IonSelectOption>
                            );
                        }
                    })}
                </IonSelect>
            </div>
        </div>
    )

};

export default UserManagerEditUserRules;